import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex justify-center items-center h-screen" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "flex flex-col mt-8"
}
const _hoisted_5 = { class: "flex justify-between items-center mb-6 mt-6" }
const _hoisted_6 = { class: "py-2 -my-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8" }
const _hoisted_7 = { class: "inline-block min-w-full overflow-hidden align-middle border-b border-gray-200 shadow sm:rounded-lg" }
const _hoisted_8 = { class: "min-w-full" }
const _hoisted_9 = { class: "bg-white" }
const _hoisted_10 = { class: "px-6 py-4 border-b border-gray-200 whitespace-nowrap text-sm" }
const _hoisted_11 = { class: "px-6 py-4 border-b border-gray-200 whitespace-nowrap text-sm" }
const _hoisted_12 = { class: "px-6 py-4 border-b border-gray-200 whitespace-nowrap text-sm" }
const _hoisted_13 = { class: "px-6 py-4 border-b border-gray-200 whitespace-nowrap text-sm" }
const _hoisted_14 = { class: "px-6 py-4 border-b border-gray-200 whitespace-nowrap text-sm" }
const _hoisted_15 = { class: "px-6 py-4 border-b border-gray-200 whitespace-nowrap text-sm" }
const _hoisted_16 = { class: "px-6 py-4 border-b border-gray-200 whitespace-nowrap text-sm" }
const _hoisted_17 = { class: "px-6 py-4 border-b border-gray-200 whitespace-nowrap text-sm" }
const _hoisted_18 = { class: "flex gap-6" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 0,
  class: "w-full text-center py-4 text-sm normal-case text-gray-500"
}
const _hoisted_23 = { class: "z-50 w-11/12 mx-auto overflow-y-auto bg-white rounded shadow-lg modal-container md:max-w-6xl h-4/5" }
const _hoisted_24 = { class: "absolute top-0 right-0 z-50 flex flex-col items-center mt-4 mr-4 text-sm text-white cursor-pointer modal-close" }
const _hoisted_25 = { class: "z-50 w-11/12 mx-auto overflow-y-auto bg-white rounded shadow-lg modal-container md:max-w-6xl h-4/5" }
const _hoisted_26 = { class: "absolute top-0 right-0 z-50 flex flex-col items-center mt-4 mr-4 text-sm text-white cursor-pointer modal-close" }
const _hoisted_27 = { class: "z-50 w-11/12 mx-auto overflow-y-auto bg-white rounded shadow-lg modal-container md:max-w-6xl h-4/5" }
const _hoisted_28 = { class: "absolute top-0 right-0 z-50 flex flex-col items-center mt-4 mr-4 text-sm text-white cursor-pointer modal-close" }

import { ref, watch, onMounted, computed } from "vue";
import axios from "axios";
import Breadcrumb from "../partials/AppBreadcrumb.vue";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import NewBlogModal from "@/components/blogs/NewBlogModal.vue";
import ViewBlogModal from "@/components/blogs/ViewBlogModal.vue";
import EditBlogModal from "@/components/blogs/EditBlogModal.vue";
import Swal from "sweetalert2";
import loader from "../assets/loader.svg";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppBlogs',
  setup(__props) {

const baseUrl = process.env.VUE_APP_BASE_URL;
const blogs = ref([]);
const loading = ref(true);
const tableHeadings = ["title", "category", "type", "status", "created at", "published at", "views", "action"];
const newBlogModalOpen = ref(false);
const viewBlogModalOpen = ref(false);
const editBlogModalOpen = ref(false);
const selectedBlogId = ref();
const categories = ref([]);
const statuses = ref([]);
const types = ref([]);
const userRoleId = localStorage.getItem("user_role_id");
const isLoading = ref(true);

const formatDate = (date: string) => {
  if (date === null || date === undefined || date === "null") {
    return "N/A";
  } else {
    return new Date(date).toLocaleDateString();
  }
};

const fetchBlogs = async () => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(`${baseUrl}/blog/get`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    blogs.value = response.data.data;
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
  }
};

const fetchCategories = () => {
  const token = localStorage.getItem("token");

  axios
    .get(`${baseUrl}/blog-category/get`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      categories.value = response.data.data;
    })
    .catch((error) => {
      console.error(error);
    });
};

const fetchStatuses = () => {
  const token = localStorage.getItem("token");

  axios
    .get(`${baseUrl}/blog-status/get`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      statuses.value = response.data.data;
    })
    .catch((error) => {
      console.error(error);
    });
};

const fetchTypes = () => {
  const token = localStorage.getItem("token");

  axios
    .get(`${baseUrl}/blog-type/get`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      types.value = response.data.data;
    })
    .catch((error) => {
      console.error(error);
    });
};

const initialProcess = async () => {
  await fetchBlogs();
  fetchCategories();
  fetchStatuses();
  fetchTypes();
};

onMounted(() => {
  initialProcess();
});

const openDeleteModal = (id, status_id) => {
  if (status_id === 1) {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteBlog(id);
      }
    });
  } else {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "You cannot delete an approved/ published blog!",
    });
  }
};

const deleteBlog = (id) => {
  const token = localStorage.getItem("token");
  axios
    .delete(`${baseUrl}/blog/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      Swal.fire("Deleted!", "Your file has been deleted.", "success");
      fetchBlogs();
    })
    .catch((error) => {
      console.error(error);
    });
};

const openViewBlogModal = (id) => {
  viewBlogModalOpen.value = true;
  selectedBlogId.value = id;
};

const openEditBlogModal = (id) => {
  editBlogModalOpen.value = true;
  selectedBlogId.value = id;
};

watch(newBlogModalOpen, (value) => {
  if (!value) {
    fetchBlogs();
  }
});

watch(viewBlogModalOpen, (value) => {
  if (!value) {
    fetchBlogs();
  }
});

watch(editBlogModalOpen, (value) => {
  if (!value) {
    fetchBlogs();
  }
});

watch([blogs, categories, statuses, types], () => {
  if (blogs.value.length > 0 && categories.value.length > 0 && statuses.value.length > 0 && types.value.length > 0) {
    isLoading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Breadcrumb, { breadcrumb: "Blogs" }),
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _unref(loader),
              alt: "Loading...",
              class: "w-8 h-8"
            }, null, 8, _hoisted_3)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "text-xl font-semibold leading-tight text-gray-700" }, "Blogs", -1)),
            (_unref(userRoleId) === '1')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "px-4 py-2 font-medium tracking-wide text-white capitalize transition-colors duration-200 transform bg-indigo-600 rounded-md hover:bg-indigo-500 focus:outline-none focus:bg-indigo-500",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (newBlogModalOpen.value = true))
                }, " Create new blog "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("table", _hoisted_8, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tableHeadings, (heading, index) => {
                      return _createElementVNode("th", {
                        key: index,
                        class: "px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50 whitespace-nowrap"
                      }, _toDisplayString(heading), 1)
                    }), 64))
                  ])
                ]),
                _createElementVNode("tbody", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(blogs.value, (blog, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_10, _toDisplayString(blog.title), 1),
                      _createElementVNode("td", _hoisted_11, _toDisplayString(blog.category.name), 1),
                      _createElementVNode("td", _hoisted_12, _toDisplayString(blog.type.name), 1),
                      _createElementVNode("td", _hoisted_13, [
                        _createElementVNode("span", {
                          class: _normalizeClass([
                      blog.status.name === 'published'
                        ? 'text-blue-500 bg-blue-100'
                        : blog.status.name === 'approved'
                        ? 'text-green-500 bg-green-100'
                        : blog.status.name === 'refused'
                        ? 'text-red-500 bg-red-100'
                        : blog.status.name === 'unpublished'
                        ? 'text-orange-500 bg-red-100'
                        : 'text-amber-500 bg-amber-100'
                    , "inline-flex px-2 py-1 text-xs font-semibold leading-5 rounded-full"])
                        }, _toDisplayString(blog.status.name), 3)
                      ]),
                      _createElementVNode("td", _hoisted_14, _toDisplayString(formatDate(blog.created_at)), 1),
                      _createElementVNode("td", _hoisted_15, _toDisplayString(blog.published_at ? formatDate(blog.published_at) : "N/A"), 1),
                      _createElementVNode("td", _hoisted_16, _toDisplayString(Math.floor(blog.views)), 1),
                      _createElementVNode("td", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("span", {
                            class: "cursor-pointer",
                            onClick: ($event: any) => (openViewBlogModal(blog.id))
                          }, _cache[8] || (_cache[8] = [
                            _createElementVNode("svg", {
                              xmlns: "http://www.w3.org/2000/svg",
                              fill: "none",
                              viewBox: "0 0 24 24",
                              "stroke-width": "1.5",
                              stroke: "currentColor",
                              class: "h-5 w-5 text-gray-700"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                d: "M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                              }),
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                              })
                            ], -1)
                          ]), 8, _hoisted_19),
                          _createElementVNode("span", {
                            class: "cursor-pointer",
                            onClick: ($event: any) => (openEditBlogModal(blog.id))
                          }, _cache[9] || (_cache[9] = [
                            _createElementVNode("svg", {
                              xmlns: "http://www.w3.org/2000/svg",
                              fill: "none",
                              viewBox: "0 0 24 24",
                              "stroke-width": "1.5",
                              stroke: "currentColor",
                              class: "h-5 w-5 text-gray-700"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                d: "m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                              })
                            ], -1)
                          ]), 8, _hoisted_20),
                          _createElementVNode("span", {
                            class: "cursor-pointer",
                            onClick: ($event: any) => (openDeleteModal(blog.id, blog.status_id))
                          }, _cache[10] || (_cache[10] = [
                            _createElementVNode("svg", {
                              xmlns: "http://www.w3.org/2000/svg",
                              fill: "none",
                              viewBox: "0 0 24 24",
                              "stroke-width": "1.5",
                              stroke: "currentColor",
                              class: "h-5 w-5 text-red-700"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                d: "m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                              })
                            ], -1)
                          ]), 8, _hoisted_21)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              (blogs.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, "No blogs to display"))
                : _createCommentVNode("", true)
            ])
          ])
        ])),
    _createElementVNode("div", {
      class: _normalizeClass(`modal ${!newBlogModalOpen.value && 'opacity-0 pointer-events-none'} z-50 fixed w-full h-full top-0 left-0 flex items-center justify-center`)
    }, [
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (newBlogModalOpen.value = false)),
        class: "absolute w-full h-full bg-gray-900 opacity-50 modal-overlay"
      }),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", {
            class: "z-50 cursor-pointer modal-close",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (newBlogModalOpen.value = false))
          }, _cache[11] || (_cache[11] = [
            _createElementVNode("svg", {
              class: "text-white fill-current",
              xmlns: "http://www.w3.org/2000/svg",
              width: "18",
              height: "18",
              viewBox: "0 0 18 18"
            }, [
              _createElementVNode("path", { d: "M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" })
            ], -1)
          ]))
        ]),
        _createVNode(NewBlogModal, {
          categories: categories.value,
          types: types.value
        }, null, 8, ["categories", "types"])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(`modal ${!viewBlogModalOpen.value && 'opacity-0 pointer-events-none'} z-50 fixed w-full h-full top-0 left-0 flex items-center justify-center`)
    }, [
      _createElementVNode("div", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (viewBlogModalOpen.value = false)),
        class: "absolute w-full h-full bg-gray-900 opacity-50 modal-overlay"
      }),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", {
            class: "z-50 cursor-pointer modal-close",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (viewBlogModalOpen.value = false))
          }, _cache[12] || (_cache[12] = [
            _createElementVNode("svg", {
              class: "text-white fill-current",
              xmlns: "http://www.w3.org/2000/svg",
              width: "18",
              height: "18",
              viewBox: "0 0 18 18"
            }, [
              _createElementVNode("path", { d: "M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" })
            ], -1)
          ]))
        ]),
        _createVNode(ViewBlogModal, {
          id: selectedBlogId.value,
          statuses: statuses.value,
          categories: categories.value,
          types: types.value
        }, null, 8, ["id", "statuses", "categories", "types"])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(`modal ${!editBlogModalOpen.value && 'opacity-0 pointer-events-none'} z-50 fixed w-full h-full top-0 left-0 flex items-center justify-center`)
    }, [
      _createElementVNode("div", {
        onClick: _cache[5] || (_cache[5] = ($event: any) => (editBlogModalOpen.value = false)),
        class: "absolute w-full h-full bg-gray-900 opacity-50 modal-overlay"
      }),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", {
            class: "z-50 cursor-pointer modal-close",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (editBlogModalOpen.value = false))
          }, _cache[13] || (_cache[13] = [
            _createElementVNode("svg", {
              class: "text-white fill-current",
              xmlns: "http://www.w3.org/2000/svg",
              width: "18",
              height: "18",
              viewBox: "0 0 18 18"
            }, [
              _createElementVNode("path", { d: "M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" })
            ], -1)
          ]))
        ]),
        _createVNode(EditBlogModal, {
          id: selectedBlogId.value,
          categories: categories.value,
          types: types.value
        }, null, 8, ["id", "categories", "types"])
      ])
    ], 2)
  ]))
}
}

})